import './CdiStatusForm.scss'

import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'
import normBoolean from "../../Form/Normalizer/boolean.js"
import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx"
import Toggle from "../../../../shared/components/Form/Field/Toggle.jsx"
import connectModal from "../../../../shared/components/Modals/connect.js"

import CdiStatusFormModal from "../../../../shared/components/Modals/CdiStatusFormModal/CdiStatusFormModal.jsx"

export const name = 'CdiStatusForm'

class CdiStatusForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      shouldResetForm: false,
    }
  }
  initialiseForm = () => {
    this.props.reset()
  }
  confirmModal = (confirmAction) => {
    const freelance = this.props?.initialValues?.freelance ?? {}
    const user = this.props?.initialValues?.user ?? {}

    this.props.openCdiStatusFormModal({
      header: 'Je suis en CDI',
      className: 'cdi-status-form-modal',
      freelance: freelance,
      user: user,
      handleCdiStatusChange: this.props.handleCdiStatusChange,
      confirmAction: confirmAction,
      onCancel: () => this.setState({shouldResetForm: true}),
    })
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevState.shouldResetForm !== this.state.shouldResetForm && !!this.state.shouldResetForm){
      this.initialiseForm()
      this.setState({shouldResetForm: false})
    }
  }

  onCdiStatusFormChange = (event, value) => {
    if(value) {
      this.confirmModal(() => this.props.handleCdiStatusChange({cdi: value}))
      return
    }
    this.props.handleCdiStatusChange({cdi: value})
  }


  render() {
    return (
      <div id={name} className="cdi-status-form">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            return
          }}
        >
          <CardRow justify="center">
            <CardCol align="center">
              <Field
                name={`freelance.cdi`}
                firstLabel={'Consultant'}
                secondLabel={'Salarié en CDI'}
                disabled={false}
                icons={false}
                normalize={normBoolean}
                component={Toggle}
                onChange={this.onCdiStatusFormChange}
              />
            </CardCol>
          </CardRow>
        </form>
      </div>
    )
  }
}

let ReduxCdiStatusForm = reduxForm({
  form: name,
})(CdiStatusForm)

export default connectModal({CdiStatusFormModal}, ReduxCdiStatusForm)
